import { BaseQueovalItem } from "../global";

export class BlocRecherche {

  public Ident: string;

  public NomBloc: string;

  public TypeBloc: string;

  public BOName: string;

  // Pour savoir si le bloc est visible par l'internaute (côté online market)
  public IntVisible: number;

  public CodeColumn: string;

  public InfoColumn: string;

  public Condition: string;
  
  public Value: string;

  public Operator: string;

  public Column: string;

  // sert uniquement pour l'affichage de la value des blocs types INT ou MONEY, plus précisément pour l'appeler dans les ngModel
  public ValueInt: number;

  // sert uniquement pour l'affichage de la value des blocs types DATETIME, plus précisément pour l'appeler dans les ngModel
  public ValueDateDebut: string;

  public ValueDateFin: string;

  // sert uniquement pour l'affichage
  public Display: boolean;
   
  public ValueSelectGroupFOR: Array<BaseQueovalItem>;

  //Sert pour regrouper des type de bloc dans un nouveau type ( ngSwitchCase impossible avec plusieurs condition dans un meme case) 
  public GroupType: string;

  constructor() {
    this.Condition = '';

    this.Display = false;
  }
}
